import { ActionTree } from 'vuex';
import { StateInterface } from '@/interfaces/projects';
import { SampleDetails } from '@/interfaces/samples';
import sampleDetails from '@/store/sampleDetails';


const actions: ActionTree<SampleDetails, StateInterface> = {
    setSampleId(state, sampleId) {
        state.commit('setSampleId', sampleId);
    },
    setSampleName(state, nombre) {
        state.commit('setSampleName', nombre);
    },
    setSampleClientId(state, clientId) {
        state.commit('setSampleClientId', clientId);
    },
    setSampleProjectId(state, projectId) {
        state.commit('setSampleProjectId', projectId);
    },
    setFechaCreacion(state, fecha_creacion) {
        state.commit('setFechaCreacion', fecha_creacion);
    },
    setIdConfFilesGrupo(state, id_conf_files_grupo) {
        state.commit('setIdConfFilesGrupo', id_conf_files_grupo);
    },
    setEjecucion(state, ejecucion) {
        state.commit('setEjecucion', ejecucion);
    },
    setSampleTotal(state, sampleTotal) {
        state.commit('setSampleTotal', sampleTotal);
    },
    setSampleReview(state, sampleReview) {
        state.commit('setSampleReview', sampleReview);
    },
    setEditSample(state, editSample) {
        state.commit('setEditSample', editSample);
    },
    setDeleteUnreviewed(state, deleteUnreviewed) {
        state.commit('setDeleteUnreviewed', deleteUnreviewed);
    },
    setShowAddDocTypesModal(state, showAddDocTypesModal) {
        state.commit('setShowAddDocTypesModal', showAddDocTypesModal);
    },
    setReloadSamplesList(state, reloadSamplesList) {
        state.commit('setReloadSamplesList', reloadSamplesList);
    },
    resetSampleDetails(state) {
        const baseSampleDetails = {
            id_muestra: 0,
            nombre: "",
            id_cliente: 0,
            id_proyecto: 0,
            fecha_creacion: "",
            id_conf_files_grupo: 0,
            ejecucion: 0,
            sampleTotal: 0,
            sampleReview: 0,
            editSample: false
          };
          state.commit('setSampleId', baseSampleDetails.id_muestra);
          state.commit('setSampleName', baseSampleDetails.nombre);
          state.commit('setSampleClientId', baseSampleDetails.id_cliente);
          state.commit('setSampleProjectId', baseSampleDetails.id_proyecto);
          state.commit('setFechaCreacion', baseSampleDetails.fecha_creacion);
          state.commit('setIdConfFilesGrupo', baseSampleDetails.id_conf_files_grupo);
          state.commit('setEjecucion', baseSampleDetails.ejecucion);

          state.commit('setSampleTotal', baseSampleDetails.sampleTotal);
          state.commit('setSampleReview', baseSampleDetails.sampleReview);
          state.commit('setEditSample', baseSampleDetails.editSample);
    }
}



export default actions;